import { Certification } from '../types';

export const certifications: Certification[] = [
  {
    id: 'ccna',
    name: 'certifications.items.ccna.name',
    issuer: 'certifications.items.ccna.issuer',
    description: 'certifications.items.ccna.description',
  },
  {
    id: 'cpp',
    name: 'certifications.items.cpp.name',
    issuer: 'certifications.items.cpp.issuer',
    description: 'certifications.items.cpp.description',
  },
  {
    id: 'rust',
    name: 'certifications.items.rust.name',
    issuer: 'certifications.items.rust.issuer',
    description: 'certifications.items.rust.description',
  },
  {
    id: 'go',
    name: 'certifications.items.go.name',
    issuer: 'certifications.items.go.issuer',
    description: 'certifications.items.go.description',
  },
  {
    id: 'yocto',
    name: 'certifications.items.yocto.name',
    issuer: 'certifications.items.yocto.issuer',
    description: 'certifications.items.yocto.description',
  },
];
